import type { Audience } from '../types'
import type { Theme } from './types'
import { lemonade } from './lemonade'
import { modern } from './modern'

// The chat widget always renders the Lemonade theme — the outer A/B test now
// pits the chat (this app) against the calculator at forsikringstjek-unge.
// `modern` is kept here for an optional future inner theme test.
export const themes = {
  lemonade,
  modern,
} as const

export type ThemeName = keyof typeof themes
export const DEFAULT_THEME: ThemeName = 'lemonade'

/**
 * Map audience → which theme the chat widget should render. Both segments use
 * `lemonade` for now; an aeldre-specific theme is a planned design follow-up.
 */
export const audienceToTheme: Record<Audience, ThemeName> = {
  unge: 'lemonade',
  aeldre: 'lemonade',
}

export type { Theme }
